import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RBLocation  } from '../Models/Location';
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'src/app/core/Services/shared.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()

export class LocationService {
    constructor(private _http: HttpClient, private _shared: SharedService) {}

    // Get All Locations
    getLocations(): Observable<RBLocation[]> {
        return this._http.get<RBLocation[]>(this._shared.apiPath + 'locations').pipe(catchError(this._shared.handleError));
    }

    // Get Location by ID
    getLocationById(locationID: number): Promise<RBLocation> {
        return this._http.get<RBLocation>(`${this._shared.apiPath}locations/${locationID}`)
            .pipe(map(r => {return <RBLocation>r['result']}), catchError(this._shared.handleError)).toPromise();
    }

    // Add Location
    addLocation(location: RBLocation): Observable<any> {
        return this._http.post<any>(`${this._shared.apiPath}locations`, location).pipe(catchError(this._shared.handleError));
    }

    // Update Location
    updateLocation(location: RBLocation): Observable<any> {
        return this._http.put<any>(`${this._shared.apiPath}locations/${location.locationID}`, location).pipe(catchError(this._shared.handleError));
    }

    // Archive service center
    archiveServiceCenter(locationID: number, isRegional: string): Observable<any> {
        return this._http.delete<any>(`${this._shared.apiPath}locations/${locationID}`).pipe(catchError(this._shared.handleError));
    }

    // Change member visibility
    updateMemberVisibility(regionID: number, teammemberID: number, data): Observable<any> {
        return this._http.put<any>(`${this._shared.apiPath}regionalMemberVisibility/${regionID}/${teammemberID}`, data).pipe(catchError(this._shared.handleError));
    }

    // Update Regional Team Order
    updateTeamOrder(regionID: number, order: any): Observable<any> {
        return this._http.put<any>(`${this._shared.apiPath}regionalOrder/${regionID}`, order).pipe(catchError(this._shared.handleError));
    }

    // Link member to Regional Service center
    linkMemberToRegion(regionID: number, teammemberID: number): Promise<any> {
        return this._http.post<any>(`${this._shared.apiPath}regionalTeamAlignment/${regionID}/${teammemberID}`, {}).pipe(catchError(this._shared.handleError)).toPromise();
    }
    
    // Unlink member from Regional Service center
    unlinkMemberFromRegion(regionID: number, teammemberID: number): Observable<any> {
        return this._http.delete<any>(`${this._shared.apiPath}regionalTeamAlignment/${regionID}/${teammemberID}`, {}).pipe(catchError(this._shared.handleError));
    }

    // Get Regions by countryCode
    getRegions(): Observable<any> {
        return this._http.get<any>(`${this._shared.apiPath}regions`).pipe(catchError(this._shared.handleError));
    }
}